import { HandCoins } from '@phosphor-icons/react';

export default HandCoins;
